module.exports = __webpack_public_path__ + "static/media/ic_二维码.58ea5a04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_二维码.svg
// module id = 372
// module chunks = 0